import { render, staticRenderFns } from "./ResetPasswordEmailSend.vue?vue&type=template&id=2b4bb6ac&scoped=true&"
import script from "./ResetPasswordEmailSend.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordEmailSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4bb6ac",
  null
  
)

export default component.exports